import { Box, Flex, Text } from "@chakra-ui/react";
import { FaExclamationTriangle, FaFileInvoiceDollar, FaShip } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ManagementFunnelCard } from "../../../models/Management";
import { crm, Pill, ResponsibleChip } from "../../../theme";
import StatusTimer from "../../../components/StatusTimeline/StatusTimer";

const fmtDate = (v?: string) =>
  v ? new Date(v).toLocaleDateString("pt-BR") : undefined;

const ProcessCard = ({
  card,
  onDragStart,
  onClick,
}: {
  card: ManagementFunnelCard;
  onDragStart: (e: React.DragEvent, card: ManagementFunnelCard) => void;
  onClick: (card: ManagementFunnelCard) => void;
}) => {
  const eta = fmtDate(card.eta);
  const navigate = useNavigate();

  return (
    <Box
      role="group"
      draggable
      onDragStart={(e) => onDragStart(e, card)}
      onClick={() => onClick(card)}
      bg={crm.surface}
      borderRadius="10px"
      border={`1px solid ${card.isAtrasado ? crm.danger : crm.border}`}
      boxShadow={crm.shadowSm}
      p="12px"
      cursor="grab"
      _hover={{
        boxShadow: crm.shadowMd,
        transform: "translateY(-1px)",
        borderColor: crm.brand,
      }}
      _active={{ cursor: "grabbing" }}
      transition="all .12s ease"
    >
      <Flex justifyContent="space-between" alignItems="flex-start" gap="8px">
        <Text fontWeight="600" color={crm.text} fontSize="sm">
          #{card.ref}
        </Text>
        <Flex align="center" gap="4px" flexShrink={0}>
          {card.poNumber != null && (
            <Box
              as="span"
              title="Abrir ordem de compra"
              cursor="pointer"
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                navigate(`/savePurchaseOrders?id=${card.purchaseOrderId}`);
              }}
            >
              <Pill bg={crm.subtle} color={crm.textMuted}>
                <FaFileInvoiceDollar size={9} /> PO {card.poNumber}
              </Pill>
            </Box>
          )}
          {card.isUrgent && (
            <Pill bg="#fef2f2" color={crm.danger}>
              <FaExclamationTriangle size={9} /> Urgente
            </Pill>
          )}
        </Flex>
      </Flex>

      {card.clientName && (
        <Text fontSize="sm" color={crm.text} mt="6px" noOfLines={1}>
          {card.clientName}
        </Text>
      )}

      {card.transportMode && (
        <Flex align="center" gap="6px" mt="4px" color={crm.textMuted}>
          <FaShip size={11} />
          <Text fontSize="xs">{card.transportMode}</Text>
        </Flex>
      )}

      {card.statusSince && (
        <StatusTimer since={card.statusSince} prefix="há " suffix=" no status" display="block" mt="4px" />
      )}

      <Flex mt="10px" gap="6px" flexWrap="wrap" alignItems="center">
        {card.responsibleName && (
          <ResponsibleChip name={card.responsibleName} />
        )}
        {eta && (
          <Pill
            bg={card.isAtrasado ? "#fef2f2" : crm.brandSoft}
            color={card.isAtrasado ? crm.danger : crm.brand}
          >
            ETA {eta}
          </Pill>
        )}
      </Flex>
    </Box>
  );
};

export default ProcessCard;
